import { GetApp } from "../../App"
import { BlockField, BlockRow } from "../../Components/Block"
import { GetData } from "./Context"
import { PrintTripListViewProps } from "./Params"

export function PrintTripListView({ trip }: PrintTripListViewProps) {
  const app = GetApp();
  const _data = GetData();
  const tc = app.getT("PrintView");
  const _t = app.getT("DayEditView");
  const _ts = app.getT("StatsView");
  const calculated = trip.calculated;

  return (
    <div className="PrintTripListView ">
      <BlockRow className="print-trip-list-row">
        <BlockField label={`${tc("trip")} | ${tc("from_loc")}`} className="block-field-270"> {trip.title}</BlockField>
        <BlockField label={`${tc("date")} | ${tc("to_loc")}`} className="block-field-270"> {app.format("date", trip.startedAt)} - {app.format("date", trip.completedAt)}</BlockField>

        <BlockField label={`${tc("time_total")} | ${tc("distance_total")}`} className="block-field-120 print-field-text-right"> {app.format("timeh", calculated?.duration)}</BlockField>
      </BlockRow>
      <BlockRow className="print-trip-list-row-2">
        <BlockField className="block-field-270"> {calculated?.startLocation}</BlockField>
        <BlockField className="block-field-270"> {calculated?.endLocation}</BlockField>
        <BlockField className="block-field-120 print-field-text-right"> {app.format("distance", calculated?.distance)}</BlockField>
      </BlockRow>
    </div>
  );
}
